module.exports = __webpack_public_path__ + "img/b59eb35.webp";